import axios from 'axios';

type Response = {
  success: boolean;
  errorMessage?: string;
};

interface UserLocaleApi {
  put: (userId: number, locale: string) => Promise<Response>;
}

export const userLocaleApi: UserLocaleApi = {
  put: async (userId, locale) => {
    try {
      const response = await axios.put(`/api/v1/users/${userId}/locale`, {
        locale,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
};
